import { ActivityGroupProps } from '~/bootcamp/Activities/types/activities.types'

import FractionCancelChoose from './FractionCancelChoose/FractionCancelChoose'
import FractionCancelEval from './FractionCancelEval/FractionCancelEval'
import FractionExpand from './FractionExpand/FractionExpand'
import FractionExpandDenom from './FractionExpandDenom/FractionExpandDenom'
import FractionExpandNum from './FractionExpandNum/FractionExpandNum'
import FractionCancel from './FractionFactors/FractionCancel'
import FractionCancelFactors from './FractionFactors/FractionCancelFactors'
import FractionCancelMultiFactors from './FractionFactors/FractionCancelMultiFactors'
import FractionImproperToMixed from './FractionImproperToMixed/FractionImproperToMixed'
import FractionImproperToMixedChoose from './FractionImproperToMixedChoose/FractionImproperToMixedChoose'
import FractionInteger from './FractionInteger/FractionInteger'
import FractionMixedToImproper from './FractionMixedToImproper/FractionMixedToImproper'
import FractionMixedToImproperChoose from './FractionMixedToImproper/FractionMixedToImproperChoose'
import FractionSimplify from './FractionSimplify/FractionSimplify'
import FractionSimplifyDenom from './FractionSimplifyDenom/FractionSimplifyDenom'
import FractionSimplifyDivisor from './FractionSimplifyDivisor/FractionSimplifyDivisor'
import FractionSimplifySelect from './FractionSimplifySelect/FractionSimplifySelect'
import UnitFractionDecimal from './UnitFraction/UnitFractionDecimal'
import UnitFractionFraction from './UnitFraction/UnitFractionFraction'
import UnitFractionNumline from './UnitFraction/UnitFractionNumline'
import UnitFractionOrder from './UnitFraction/UnitFractionOrder'

const Bootcamp2Activities = ({ activityName, ...props }: ActivityGroupProps): React.ReactElement => {
  switch (activityName) {
    case 'UnitFractionDecimal':
      return <UnitFractionDecimal {...props} />
    case 'UnitFractionFraction':
      return <UnitFractionFraction {...props} />
    case 'UnitFractionOrder':
      return <UnitFractionOrder {...props} />
    case 'UnitFractionNumline':
      return <UnitFractionNumline {...props} />
    case 'FractionExpand':
      return <FractionExpand {...props} />
    case 'FractionExpandNum':
      return <FractionExpandNum {...props} />
    case 'FractionExpandDenom':
      return <FractionExpandDenom {...props} />
    case 'FractionSimplifySelect':
      return <FractionSimplifySelect {...props} />
    case 'FractionSimplifyDivisor':
      return <FractionSimplifyDivisor {...props} />
    case 'FractionSimplifyDenom':
      return <FractionSimplifyDenom {...props} />
    case 'FractionCancelFactors':
      return <FractionCancelFactors {...props} />
    case 'FractionCancelMultiFactors':
      return <FractionCancelMultiFactors {...props} />
    case 'FractionCancel':
      return <FractionCancel {...props} />
    case 'FractionCancelEval':
      return <FractionCancelEval {...props} />
    case 'FractionCancelChoose':
      return <FractionCancelChoose {...props} />
    case 'FractionSimplify':
      return <FractionSimplify {...props} />
    case 'FractionInteger':
      return <FractionInteger {...props} />
    case 'FractionImproperToMixedChoose':
      return <FractionImproperToMixedChoose {...props} />
    case 'FractionImproperToMixed':
      return <FractionImproperToMixed {...props} />
    case 'FractionMixedToImproperChoose':
      return <FractionMixedToImproperChoose {...props} />
    case 'FractionMixedToImproper':
      return <FractionMixedToImproper {...props} />
    default:
      return <></>
  }
}

export default Bootcamp2Activities
